<div class="icon-div" [ngStyle]="{'height': height, 'width': width, color: color}">
  <i class="ppi ppi-{{name}}"></i>
</div>
